import SyntheseEntityCtrlEnrobesController from './syntheseentities.ctrlenrobes.controller';

export default {
    template: require('./syntheseentities.ctrlenrobes.html'),
    controller: SyntheseEntityCtrlEnrobesController
};
